import React, { useEffect, useMemo, useState } from 'react';

const Image = (props) => {
    console.log('Image', props)
    return (<>

    </>);
};

export default Image;